import { render } from "./SpacesYourGroups.vue?vue&type=template&id=3f15face&scoped=true&ts=true"
import script from "./SpacesYourGroups.vue?vue&type=script&lang=ts"
export * from "./SpacesYourGroups.vue?vue&type=script&lang=ts"

import "./SpacesYourGroups.vue?vue&type=style&index=0&id=3f15face&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f15face"]])

export default __exports__